import { DeviceEffects } from './device.effect';
import { RouterEffects } from './router.effect';

export const effects: any[] = [RouterEffects, DeviceEffects];

export * from './device.effect';
export * from './router.effect';
